/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import {PropTypes} from 'preact-compat';
import GUMConfiguration from '../../gum-configuration';
import StatsView from './StatsView';
import {ResolutionSelect, AspectRatioSelect, FrameRateSelect} from './PublisherControls';
import styles from '../../../css/publisher.css';

const UserMediaPublisher = ({
  audioOnly,
  videoOnly,
  publishToChannel,
  stopPublisher,
  publisher,
  errorMessage,
  gotUserMedia,
  changeGumResolution,
  changeAspectRatio,
  changeFrameRate,
  gumResolution,
  aspectRatio,
  frameRate,
  isBusy,
  stats
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.rightColumn}>
        {!audioOnly && ([
          <ResolutionSelect
            key="resolution-select"
            changeGumResolution={changeGumResolution}
            defaultValue={gumResolution}
            disabled={!!publisher}
          />,
          <AspectRatioSelect
            key="aspect-ratio-select"
            onChange={changeAspectRatio}
            defaultValue={aspectRatio}
            disabled={!!publisher}
          />,
          <FrameRateSelect
            key="frame-rate-select"
            onChange={changeFrameRate}
            defaultValue={frameRate}
            disabled={!!publisher}
          />
        ])}

        <GUMConfiguration
          audioOnly={audioOnly}
          videoOnly={videoOnly}
          gotUserMedia={gotUserMedia}
          resolution={gumResolution}
          aspectRatio={aspectRatio}
          changeFrameRate={changeFrameRate}
          frameRate={frameRate}
          confirmUserMedia={(userMediaStream) => publishToChannel(userMediaStream)}
          includeScreen={false}
          confirmButtonText=" "
          confirmButtonDisabled={isBusy}
          classNames={{
            confirmButton: publisher ? styles.hide : styles.confirmButton,
            sourceSelect: publisher ? styles.disabled : ''
          }}
        />

        {errorMessage && (
          <h3 className={styles.errorMessage}>
            {errorMessage}
          </h3>
        )}

        {isBusy && (
          <h3 className={styles.infoMessage}>
            Please wait...
          </h3>
        )}

        {publisher && (
          <div className={styles.publisherResult}>
            <div className={styles.publisherControls}>
              <button
                className={styles.cancelPublisherButton}
                onClick={stopPublisher}/>
              <StatsView
                audioStat={stats && stats.audio ? {uploadRate: stats.audio.bitrate / 1000} : null}
                videoStat={stats && stats.video ? {uploadRate: stats.video.bitrate / 1000} : null}
                isUpload={true}/>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

UserMediaPublisher.propTypes = {
  videoOnly: PropTypes.bool,
  audioOnly: PropTypes.bool,
  publishToChannel: PropTypes.func.isRequired,
  stopPublisher: PropTypes.func.isRequired,
  publisher: PropTypes.object,
  errorMessage: PropTypes.string,
  gotUserMedia: PropTypes.func.isRequired,
  changeGumResolution: PropTypes.func.isRequired,
  changeAspectRatio: PropTypes.func.isRequired,
  changeFrameRate: PropTypes.func.isRequired,
  gumResolution: PropTypes.string,
  aspectRatio: PropTypes.string,
  frameRate: PropTypes.number,
  isBusy: PropTypes.bool,
  stats: PropTypes.shape({
    audio: PropTypes.object,
    video: PropTypes.object
  })
};

export default UserMediaPublisher;